export enum SendToEnum {
  Participants = 0,
  BoardOwners = 1,
  All = 2,
  ParticipantsWhoNotVoted = 3,
}
